import type { FieldSchema } from '@/stores'

export const transactionFilterSchema: FieldSchema[] = [
  {
    field: 'accountNumber',
    label: 'Account Number',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'accountOwner',
    label: 'Account Owner',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'accountType',
    label: 'Account Type',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'amount',
    label: 'Amount',
    type: 'number' as const,
    formatter: (value: number) => `$${parseFloat(String(value)).toFixed(2)}`,
  },
  {
    field: 'category',
    label: 'Category',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'categoryDetail',
    label: 'Category Detail',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'date',
    label: 'Date',
    type: 'date' as const,
  },
  {
    field: 'description',
    label: 'Description',
    type: 'text' as const,
  },
  {
    field: 'statementFileName',
    label: 'Document Name',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'institution',
    label: 'Institution',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'kind',
    label: 'Kind',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'merchant',
    label: 'Merchant',
    type: 'text' as const,
  },
  {
    field: 'sourcePage',
    label: 'Page Number',
    type: 'text' as const,
  },
  {
    field: 'paymentChannel',
    label: 'Payment Channel',
    type: 'select' as const,
    multiple: true,
  },
  {
    field: 'shareNumber',
    label: 'Share Number',
    type: 'select' as const,
    multiple: true,
  },
].sort((a, b) => a.label.localeCompare(b.label))

// Fields that are constant or absent on a check (tagged deterministically
// server-side), so filtering by them in the Checks view is a dead end.
const CHECK_OMITTED_FIELDS = new Set([
  'accountType',
  'category',
  'categoryDetail',
  'merchant',
  'paymentChannel',
  'shareNumber',
])

// Checks reuse the transaction filters minus the deterministic fields, plus the
// parsed check number.
export const checkFilterSchema: FieldSchema[] = [
  ...transactionFilterSchema.filter(
    (filter) => !CHECK_OMITTED_FIELDS.has(filter.field),
  ),
  {
    field: 'checkNumber',
    label: 'Check Number',
    type: 'text' as const,
  },
].sort((a, b) => a.label.localeCompare(b.label))
